function BlockSliderImages() {
	this.build();
}

BlockSliderImages.prototype.build = function(){
	this.sliders = document.querySelectorAll('.block--slider-images');
	this.sliders.forEach( (elem) => {
		const slider = elem.querySelector('.slider-images');
		const sliderDots = elem.querySelector('.slider__dots');
		const prevBtn = elem.querySelector('.slider__prev');
		const nextBtn = elem.querySelector('.slider__next');

		let multiple = false;
		let variableWidth = false;
		let centerMode = false;

		let swiper = null;

		swiper = new Swiper( slider, {
			autoplay: {
				delay: 4000,
			},
			speed: 900
		});

		$(slider).magnificPopup({
			delegate: '.swiper-slide a',
			type: 'image',
			tLoading: 'Loading image #%curr%...',
			mainClass: 'mfp-img-mobile',
			gallery: {
				// enabled: true,
				enabled: false,
				navigateByImgClick: true,
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
				titleSrc: function(item) {
					return item.el.attr('title');
				}
			}
		});

		swiper.on('slideChangeTransitionEnd', function (slider) {
			sliderDots.querySelectorAll('li').forEach( (el) => {
				el.classList.remove('current');
			});
			sliderDots.querySelector('li.item-'+slider.realIndex).classList.add('current');
		});

		sliderDots.querySelectorAll('li').forEach( (el) => {
			el.addEventListener('click', function() {
				swiper.slideTo($(this).data('slide'));
			});
		});

		prevBtn.addEventListener("click", (e) => {
			swiper.slidePrev();
		});

		nextBtn.addEventListener("click", (e) => {
			swiper.slideNext();
		});
	});
};
